module.exports = __webpack_public_path__ + "img/fileTimes.746eed92.svg";